import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Background Colors ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Easily set the background of an element to any contextual class as shown below: ", -1)
const _hoisted_6 = { class: "py-5" }
const _hoisted_7 = { class: "rounded border p-10" }
const _hoisted_8 = { class: "py-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-white"></div>
            <div class="bg-primary"></div>
            <div class="bg-light"></div>
            <div class="bg-secondary"></div>
            <div class="bg-success"></div>
            <div class="bg-info"></div>
            <div class="bg-warning"></div>
            <div class="bg-danger"></div>
            <div class="bg-dark"></div>
            `))
const _hoisted_10 = { class: "py-10" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "light-bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#light-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Light Background Colors ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's light background color defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-light-colors"),
  /*#__PURE__*/_createTextVNode(" in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_13 = { class: "py-5" }
const _hoisted_14 = { class: "rounded border p-10" }
const _hoisted_15 = { class: "py-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-light-primary text-primary"></div>
            <div class="bg-light-success text-success"></div>
            <div class="bg-light-info text-info"></div>
            <div class="bg-light-warning text-warning"></div>
            <div class="bg-light-danger text-danger"></div>
            <div class="bg-light-dark text-dark"></div>
            `))
const _hoisted_17 = { class: "py-10" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hover-bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#hover-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hover Background Colors ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".bg-hover-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's hover background color: ")
], -1)
const _hoisted_20 = { class: "py-5" }
const _hoisted_21 = { class: "rounded border p-10" }
const _hoisted_22 = { class: "py-5" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-hover-white"></div>
            <div class="bg-hover-primary"></div>
            <div class="bg-hover-light"></div>
            <div class="bg-hover-secondary"></div>
            <div class="bg-hover-success"></div>
            <div class="bg-hover-info"></div>
            <div class="bg-hover-warning"></div>
            <div class="bg-hover-danger"></div>
            <div class="bg-hover-dark"></div>
            `))
const _hoisted_24 = { class: "py-10" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hover-light-bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#hover-light-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hover Light Background Colors ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".bg-hover-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's hover light background color: ")
], -1)
const _hoisted_27 = { class: "py-5" }
const _hoisted_28 = { class: "rounded border p-10" }
const _hoisted_29 = { class: "py-5" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-hover-light-primary"></div>
            <div class="bg-hover-light-success"></div>
            <div class="bg-hover-light-info"></div>
            <div class="bg-hover-light-warning"></div>
            <div class="bg-hover-light-danger"></div>
            <div class="bg-hover-light-dark"></div>
            `))
const _hoisted_31 = { class: "py-10" }
const _hoisted_32 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hoverable-bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#hoverable-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hoverable Background Colors ")
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".hoverable"),
  /*#__PURE__*/_createTextVNode(" with "),
  /*#__PURE__*/_createVNode("code", null, ".bg-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's background color with hover state: ")
], -1)
const _hoisted_34 = { class: "py-5" }
const _hoisted_35 = { class: "rounded border p-10" }
const _hoisted_36 = { class: "py-5" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-white hoverable"></div>
            <div class="bg-primary hoverable"></div>
            <div class="bg-light hoverable"></div>
            <div class="bg-secondary hoverable"></div>
            <div class="bg-success hoverable"></div>
            <div class="bg-info hoverable"></div>
            <div class="bg-warning hoverable"></div>
            <div class="bg-danger hoverable"></div>
            <div class="bg-dark hoverable"></div>
            `))
const _hoisted_38 = { class: "py-10" }
const _hoisted_39 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "hoverable-bg-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#hoverable-bg-colors" }),
  /*#__PURE__*/_createTextVNode(" Hoverable Light Background Colors ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".hoverable"),
  /*#__PURE__*/_createTextVNode(" with "),
  /*#__PURE__*/_createVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's light background color with hover state: ")
], -1)
const _hoisted_41 = { class: "py-5" }
const _hoisted_42 = { class: "rounded border p-10" }
const _hoisted_43 = { class: "py-5" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-light-primary hoverable"></div>
            <div class="bg-light-success hoverable"></div>
            <div class="bg-light-info hoverable"></div>
            <div class="bg-light-warning hoverable"></div>
            <div class="bg-light-danger hoverable"></div>
            <div class="bg-light-dark hoverable"></div>
            `))
const _hoisted_45 = { class: "py-10" }
const _hoisted_46 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "opacity"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#opacity" }),
  /*#__PURE__*/_createTextVNode(" Opacity ")
], -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".bg-opacity-{0, 5, 10, 15, 20, 25, 50, 75, 100}"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createVNode("code", null, ".bg-{color}"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, ".bg-light-{color}"),
  /*#__PURE__*/_createTextVNode(" to set an element's background color with opacity: ")
], -1)
const _hoisted_48 = { class: "py-5" }
const _hoisted_49 = { class: "rounded border p-10 d-flex flex-wrap" }
const _hoisted_50 = { class: "fw-bold py-2" }
const _hoisted_51 = { class: "py-5" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
            <div class="bg-opacity-0 bg-primary"></div>
            <div class="bg-opacity-5 bg-primary"></div>
            <div class="bg-opacity-10 bg-primary"></div>
            <div class="bg-opacity-15 bg-primary"></div>
            <div class="bg-opacity-20 bg-primary"></div>
            <div class="bg-opacity-25 bg-primary"></div>
            <div class="bg-opacity-50 bg-primary"></div>
            <div class="bg-opacity-75 bg-primary"></div>
            <div class="bg-opacity-100 bg-primary"></div>
            `))
const _hoisted_53 = { class: "pt-10" }
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"bg-image-classes\"><a href=\"#bg-image-classes\"></a> Background Image Classes </h1><div class=\"py-5\"> Assign background image style values to an element with shorthand classes with the format <code>bgi-{property}</code>. </div><div class=\"py-5\"> Where <code>property</code> is one of: <ul class=\"pt-3\"><li class=\"py-2\"><code>size-length</code> to set <code>background-size: length</code></li><li class=\"py-2\"><code>size-cover</code> to set <code>background-size: cover</code></li><li class=\"py-2\"><code>size-contain</code> to set <code>background-size: contain</code></li><li class=\"py-2\"><code>no-repeat</code> to set <code>background-repeat: no-repeat</code></li><li class=\"py-2\"><code>position-y-top</code> to set <code>background-position-y: top</code></li><li class=\"py-2\"><code>position-y-bottom</code> to set <code>background-position-y: bottom</code></li><li class=\"py-2\"><code>position-y-center</code> to set <code>background-position-y: center</code></li><li class=\"py-2\"><code>position-x-left</code> to set <code>background-position-x: left</code></li><li class=\"py-2\"><code>position-x-right</code> to set <code>background-position-x: right</code></li><li class=\"py-2\"><code>position-x-center</code> to set <code>background-position-x: center</code></li><li class=\"py-2\"><code>position-bottom</code> to set <code>background-position: 0 bottom</code></li><li class=\"py-2\"><code>position-center</code> to set <code>background-position: center</code></li></ul></div>", 3)
const _hoisted_57 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-${item} text-inverse-${item}`, "p-3 fw-bold fw-6"]
              }, " .bg-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.lightBackgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-light-${item} text-${item}`, "p-3 fw-bold fw-6"]
              }, " .bg-light-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-hover-${item}`, "text-gray-600 p-3 fw-bold fw-6"]
              }, " .bg-hover-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.lightBackgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-hover-light-${item}`, "text-gray-600 p-3 fw-bold fw-6"]
              }, " .bg-hover-light-" + _toDisplayString(item), 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _hoisted_32,
        _hoisted_33,
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-${item}`, "text-gray-600 hoverable p-3 fw-bold fw-6"]
              }, " .bg-" + _toDisplayString(item) + " .hoverable ", 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_38, [
        _hoisted_39,
        _hoisted_40,
        _createVNode("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.backgroundColors, (item, i) => {
              return (_openBlock(), _createBlock("p", {
                key: i,
                class: [`bg-light-${item}`, "text-gray-600 hoverable p-3 fw-bold fw-6"]
              }, " .bg-light-" + _toDisplayString(item) + " .hoverable ", 3))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_45, [
        _hoisted_46,
        _hoisted_47,
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors.opacity, (item, i) => {
              return (_openBlock(), _createBlock("div", {
                key: i,
                class: "d-flex flex-column me-5 mb-5"
              }, [
                _createVNode("div", {
                  class: [`opacity-${item}`, "w-90px h-90px bg-primary flex-grow-1"]
                }, null, 2),
                _createVNode("div", _hoisted_50, "bg-opacity-" + _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_51, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_53, [
        _hoisted_54,
        _createVNode("div", _hoisted_57, [
          _createVNode(_component_CodeHighlighter, { lang: "html" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(`
            <div
              style="background-image: url(image.png)"
              class="bgi-size-contain bgi-no-repeat bgi-position-center"
            ></div>
            `), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}